import _ from 'lodash';
import {
  FETCH_USER_PRODUCT_SELECTIONS_SUCCESS,
  SAVE_USER_PRODUCT_SELECTION_REQUEST,
  DELETE_USER_PRODUCT_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import {
  DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST,
  SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST,
} from '../../../../admin/dashboard/redux/actions/types/AdminDashboardActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import {
  FETCH_MAIL_CLASSES,
  FETCH_MAIL_CLASSES_SUCCESS,
  FETCH_MAIL_CLASSES_FAILURE,
  SHOW_ONLY_SELECTED_MAIL_CLASSES,
} from '../actions/types/ProductActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

const initialState = {
  isShowOnlySelected: false,
  mailClassNodes: [],
  selections: [],
  isLoading: false,
};

function cutOffMailClassDescription(subClassDescription) {
  return subClassDescription.substr(subClassDescription.indexOf('-') + 1);
}

const includeMissingMailCategories = (selection) => {
  const requiredMailCategoryCodes = ['A', 'B', 'C', 'D'];

  const missingMailCategoryCodes = _.difference(
    requiredMailCategoryCodes,
    _.map(selection.products, 'mailCategoryCode'),
  );

  const products = [...selection.products];
  _.forEach(missingMailCategoryCodes, (missingMailCategoryCode) => {
    products.push({
      mailCategoryCode: missingMailCategoryCode,
      mailSubClasses: [],
    });
  });

  return {
    scope: selection.scope,
    name: selection.name,
    products,
  };
};

const translateName = (selection) => {
  if (selection.name === 'LAST_SELECTION') {
    return {
      ...selection,
      name: 'Your last selection',
    };
  }

  return selection;
};

const handleFetchUserProductSelectionsSuccess = (action, state) => {
  const selections = [...action.payload.selections]
    .map(includeMissingMailCategories)
    .map(translateName);
  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleSaveUserProductSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    products: action.payload.selectedProducts,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleSaveAdminProductSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    products: action.payload.selectedProducts,
    scope: 'GLOBAL',
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));

  return {
    ...state,
    selections,
  };
};

const handleDeleteUserProductSelectionRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleDeleteAdminProductSelectionRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const productSelectorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MAIL_CLASSES:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_MAIL_CLASSES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mailClassNodes: action.data.map(mailClass => ({
          label: `${mailClass.mailClass.code} - ${mailClass.mailClass.upuDescription}`,
          value: mailClass.mailClass.code,
          children: mailClass.mailSubClasses.map(mailSubClass => ({
            label: `${mailSubClass.code} - ${
              cutOffMailClassDescription(mailSubClass.upuDescription)}`,
            value: mailSubClass.code,
          })),
        })),
      };
    case FETCH_MAIL_CLASSES_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SHOW_ONLY_SELECTED_MAIL_CLASSES:
      return { ...state, isShowOnlySelected: !state.isShowOnlySelected };
    case ENTERED_WIZARD:
      return { ...state, isShowOnlySelected: false };
    case FETCH_USER_PRODUCT_SELECTIONS_SUCCESS:
      return handleFetchUserProductSelectionsSuccess(action, state);
    case SAVE_USER_PRODUCT_SELECTION_REQUEST:
      return handleSaveUserProductSelectionRequest(action, state);
    case SAVE_GLOBAL_SELECTION_PRODUCT_REQUEST:
      return handleSaveAdminProductSelectionRequest(action, state);
    case DELETE_USER_PRODUCT_SELECTION_REQUEST:
      return handleDeleteUserProductSelectionRequest(action, state);
    case DELETE_GLOBAL_SELECTION_PRODUCT_REQUEST:
      return handleDeleteAdminProductSelectionRequest(action, state);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

export default productSelectorReducer;
